import { NavLink } from "react-router-dom";
import { Mic, LayoutDashboard, MessageSquare, Volume2, ListChecks, Users, Settings, History } from "lucide-react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/manual", label: "Chamada Manual", icon: MessageSquare, testid: "nav-manual" },
  { to: "/history", label: "Histórico", icon: History, testid: "nav-history" },
  { to: "/agents", label: "Agentes", icon: Volume2, testid: "nav-agents" },
  { to: "/templates", label: "Templates", icon: ListChecks, testid: "nav-templates" },
  { to: "/aliases", label: "Nomes TTS", icon: Users, testid: "nav-aliases" },
  { to: "/settings", label: "Configurações", icon: Settings, testid: "nav-settings" },
];

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex">
      <aside data-testid="sidebar" className="hidden lg:flex fixed left-0 top-0 h-screen w-60 flex-col border-r border-panel bg-panel z-30">
        <div className="px-5 py-5 border-b border-panel flex items-center gap-2">
          <Mic className="text-[hsl(var(--primary))]" size={22} />
          <div>
            <div className="font-display text-lg leading-none uppercase tracking-tight">KGV Audio</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mt-1">Chamadas por Voz</div>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 my-0.5 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-[hsl(var(--primary))]/15 text-white border-l-2 border-[hsl(var(--primary))]"
                    : "text-gray-400 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <Icon size={16} />
              <span className="uppercase tracking-wide font-semibold text-xs">{label}</span>
            </NavLink>
          ))}
        </nav>

      </aside>
      <main className="flex-1 lg:ml-60 p-4 lg:p-6 max-w-full">{children}</main>
    </div>
  );
}
